import { Component, Input } from '@angular/core';
import { IDataCardSingleComponent } from '@pacifico/interfaces/components.interface';

@Component({
	selector: 'app-card-single',
	templateUrl: './card-single.component.html',
	styleUrls: ['./card-single.component.scss']
})
export class CardSingleComponent {
	@Input() items: IDataCardSingleComponent[] = [];
}
